export const toggleWrapper = {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '$toggleMarginVertical',
}

export const toggleButton = {
    '& > div': {textAlign: 'left'},
    'alignItems': 'center',
    'background': 'none',
    'border': 'none',
    'borderBottom': '1px solid $toggleBorder',
    'color': '$toggleButtonText',
    'cursor': 'pointer',
    'display': 'flex',
    'flexGrow': 1,
    'fontSize': '$toggleButton',
    'justifyContent': 'space-between',
    'padding': '$toggleButtonPaddingVertical 0',
    'variants': {small: {true: {fontSize: '$toggleButtonSmall'}}},
}

export const toggleContent = {
    display: 'flex',
    height: 0,
    overflow: 'hidden',
    visibility: 'hidden',
}

export const toggleContentInner = {
    display: 'flex',
    flexGrow: 1,
    padding: '$toggleContentPaddingVertical 0',
}

export const toggleIcon = {
    ' > svg': {
        marginLeft: '$toggleIconMarginHorizonal',
        width: '$toggleIcon',
    },
    'alignItems': 'center',
    'color': '$toggleIcon',
    'display': 'flex',
    'variants': {small: {true: {width: '20px'}}},
}
